<template>
  <div class="glide__slide h-auto overflow-hidden">
    <slot />
  </div>
</template>
